'use strict';

angular.module('mobile-apps')
	.directive('selectLanguageButton',[
		'AvailableLanguages',
		'EntryMain',
		'GlossaryMain',
		function(
			AvailableLanguages,
			EntryMain,
			GlossaryMain
		) {
			return {
				scope:
				{
					entryId : '@',
					selectCallback : '='
				},
				templateUrl: 'modules/mobile-apps/views/select-glossary-entry-language-button.client.view.html',
				link: function (scope, elem, attrs) {

					var availableLanguages = AvailableLanguages.get();

					scope.data = {};
					scope.data.dropdownVisible = false;
					scope.data.languages = [];


					/**
					 * Populates the languages to display and then shows
					 * the dropdown
           			 */
					scope.displayDropdown = function($event) {
						$event.preventDefault();
						$event.stopPropagation();

						var languages = scope.getAddLanguageList(scope.entryId);

						scope.data.languages.length = 0;
						languages.forEach(function(language) {
							scope.data.languages.push(language);
						});

						if (scope.data.languages.length === 0) {
							scope.data.languages.push({
								id: null,
								name: 'No more languages to add'
							});
						}

						scope.data.dropdownVisible = !scope.data.dropdownVisible;
					};


					/**
					 * Returns all the languages which can still get added
					 * for the entry with teh given id
           			 */
					scope.getAddLanguageList = function(entryId) {

						var addLanguages = [];

						var entry = GlossaryMain.entries[entryId];

						if (!entry) {
							return addLanguages;
						}

						var existingLanguages = Object.keys(entry.translations);

						for (var languageId in EntryMain.languages) {
							var language = EntryMain.languages[languageId];
							if (existingLanguages.indexOf(language.name) !== -1) {
								continue;
							}

							addLanguages.push({
								id: language.name,
								name: availableLanguages[language.name]
							});
						}

						return addLanguages;
					};


					/**
					 * Calls the select callback function when a language
					 * got selected
           			 */
					scope.languageSelected = function(language) {
						if (scope.selectCallback && language.id !== null) {
							scope.selectCallback(scope.entryId, language.id);
						}
					};


				}
			};
		}]);
